import { ProjectDocRepository } from "./ProjectDocRepository";

/** Record of item-id → done boolean. */
type PermitsChecklist = Record<string, boolean>;

class PermitsChecklistRepository extends ProjectDocRepository<PermitsChecklist> {
  readonly key = "permits-checklist";
  readonly defaultValue: PermitsChecklist = {};
}

export const permitsChecklistRepository = new PermitsChecklistRepository();
